module.exports = __webpack_public_path__ + "static/media/piloto.e931066e.png";